// extracted by mini-css-extract-plugin
export default {"tableWrapperContainer":"TheTableWrapper_tableWrapperContainer__TqgK9"};